module.exports = __webpack_public_path__ + "media/images/logo-icon-5615628e529ec128702ffe0a0dffecc4.png";